import classNames from 'classnames';
import { observer } from 'mobx-react';
import { Component } from 'react';

import summaryCss from '../../app/configurator/components/ConfigurationSummary/ConfigurationSummary.css';
import { ProductConfigurationOrigin } from '../../app/data/model';
import ActionButton from '../../app/shared/components/ActionButton';
import { ErrorMessage } from '../../app/shared/components/Input/ErrorMessages/ErrorMessages';
import InputNumber from '../../app/shared/components/InputNumber/InputNumber';
import ThreeDotsLoader from '../../app/shared/components/Loaders/ThreeDotsLoader';
import Price from '../../app/shared/components/Price';
import { Authorize } from '../authentication/Authorize';
import { AddedToCartModal } from '../configurator/AddedToCartModal/AddedToCartModal';
import configuratorActionscss from '../configurator/ConfiguratorActions.css';
import { AdminPolicy } from '../Policy';
import css from './ConfigurationDetailsActions.css';
import { ConfigurationDetailsActionsState } from './ConfigurationDetailsActionsState';

export interface ConfigurationDetailsActionsProps {
  state: ConfigurationDetailsActionsState;
}

@observer
export default class ConfigurationDetails extends Component<ConfigurationDetailsActionsProps> {
  render() {
    const state = this.props.state;
    const isRawConfiguratorOrigin = state.details.configuration.origin === ProductConfigurationOrigin.RawConfigurator;
    const priceDefined = state.codeIsValid && state.price && state.price.amount > 0;

    if (!state.store.canPurchaseProductFromRawConfiguration() || !isRawConfiguratorOrigin) {
      return null;
    }

    return (
      <Authorize policy={AdminPolicy}>
        {(state.validateConfigurationCommand.processing || state.loadPriceCommand.processing) && (
          <div className={css.loaderContainer}>
            <ThreeDotsLoader className={css.loader} size="medium" />
          </div>
        )}
        {state.codeIsValid === false && (
          <ErrorMessage
            className={css.configurationError}
            error={
              state.unableToValidateCode
                ? state.translations.unableToValidateConfigurationCode
                : state.translations.configurationInvalidOrObsolete
            }
          />
        )}
        {priceDefined && (
          <>
            <div className={classNames(summaryCss.shipmentQuantityContainer, summaryCss.showExpectedShipment)}>
              <div className={summaryCss.quantityContainer}>
                <InputNumber
                  className={summaryCss.inputNumber}
                  onChange={state.updateQuantity}
                  min={state.quantityMin}
                  max={state.quantityMax}
                  input={state.quantityInput}
                />
                <Price
                  className={summaryCss.totalPrice}
                  price={state.total}
                  taxSuffix={state.configuratorPageTranslation.priceTaxText}
                />
              </div>
            </div>
            <div className={configuratorActionscss.container}>
              {state.addToCartCommand && (
                <ActionButton className={configuratorActionscss.buttonAddToCart} command={state.addToCartCommand}>
                  {state.configurationActionsTranslation.addToCartButton}
                </ActionButton>
              )}

              {<AddedToCartModal state={state.recentlyAddedItemModal} actionType="Add" />}
            </div>
          </>
        )}
      </Authorize>
    );
  }
}
